import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import { fetchProject } from './fetchProject'

export const fetchBomItem = createAsyncThunk<any, any, { state: any }>(
  'BoM/fetchBomItem',
  async (bomItemId: string, thunkAPI) => {
    const partyId = thunkAPI.getState().user.organizationContext.id
    const projectId = thunkAPI.getState().project.activeProject?.id

    if (projectId === bomItemId) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      return null
    } else {
      const bomItemController = new BomItemController(partyId, projectId)

      return (await bomItemController.GetBomItem(bomItemId)) as PartTypeRow
    }
  }
)
